import { inject, provideAppInitializer } from '@angular/core';

import { NoxoNavigationHistory } from './navigation-history';

export const provideNoxoNavigationHistory = () =>
  provideAppInitializer(() => {
    inject(NoxoNavigationHistory);
  });
